<template>
    <b-form-file
      v-model="interface"
      :state="Boolean(interface)"
      :placeholder="placeholderText"
      :drop-placeholder="dropPlaceholderText"
      accept=".jpg, .png, .gif"
      :multiple="multiple"
      class="mt-3 upload-file"
    ></b-form-file>
</template>

<script>
export default {
    props: {
        value: {
            type: File
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        interface: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('file', val)
            }
        },

        placeholderText() {
            return this.multiple ? 'Выберите файлы или перетащите сюда ...' : 'Выберите файл или перетащите сюда ...'
        },

        dropPlaceholderText() {
            return this.multiple ? 'Перетащите файлы сюда ...' : 'Перетащите файл сюда ...'
        }
    },

    methods: {
      clearFiles() {
        this.$refs['file'].reset()
      }
    }
}
</script>

<style lang="scss" scoped>
    .upload-file::v-deep {
        .custom-file-label {
            border: none;
        }
    }
</style>
